<template>
    <div>
        <div class="modal fade modern-modal" tabindex="-1" id="ModalDadosRegistroNecessidade" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal" aria-label="Fechar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <img  src="/assets/images/sollai/icone-sollaregistro.png" alt="provisorio" class="img-responsive w-100 px-2">
                        </div>
                        <div class="header-text">
                            <h2>Registro de Necessidade do Processo</h2>
                            <p>Dados do Registro de Necessidade que deu origem ao processo.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="section-header">
                            <div class="section-info" v-if="nomeProcesso">
                                <span class="info-chip">Processo: <strong>{{ nomeProcesso }}</strong></span>
                            </div>
                        </div>

                        <div class="table-section">
                            <div class="table-section-header d-none">
                                <h4 class="section-subtitle">Itens do Registro de Necessidade</h4>
                                <p class="section-description">Lista dos itens e registros de necessidades utilizados no processo.</p>
                            </div>
                            <div class="table-wrapper modern-table">
                                <table class="custom-table" style="min-width: 100%">
                                    <thead v-if="lstDados">
                                        <tr>
                                            <th class="text-center">Registro de Necessidade</th>
                                            <th class="text-center">Setor</th>
                                            <th class="text-center">Lote</th>
                                            <th class="text-center">Item</th>
                                            <th class="text-center">Qtd. Solicitada</th>
                                            <th class="text-center">Qtd. Utilizada</th>
                                            <th class="text-center">Unidade de Medida</th>
                                            <!--<th class="text-center" style="width: 1%">Ações</th>-->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in lstDados" :key="index">
                                            <td data-label="RegistroNecessidade" class="text-center">
                                                <span>{{ item.nmRegistroNecessidade }}</span>
                                            </td>
                                            <td data-label="Setor" class="text-center">
                                                <span>{{ item.cdSetor }} {{item.nmSetor}}</span>
                                            </td>
                                            <td data-label="Lote" class="text-center">
                                                <span>Lote {{ item.nrLote }}</span>
                                            </td>
                                            <td data-label="Item" class="text-center">
                                                <div class="item-name">{{ item.nmItem || '-' }}</div>
                                                <div class="item-details">
                                                    {{ item.cdReferencia || item.cdItem || '-' }}
                                                    <span v-if="item.tpItem">• {{item.tpItem }}</span>
                                                </div>
                                            </td>
                                            <td data-label="qtdSolicitada" class="text-center">
                                                <span>{{ item.qtdSolicitada }}</span>
                                            </td>
                                            <td data-label="qtdUtilizada" class="text-center">
                                                <span>{{ item.qtdUtilizado }}</span>
                                            </td>
                                            <td data-label="nmUnidadeMedida" class="text-center">
                                                <span class="id-badge">{{ item.nmUnidadeMedida || '-' }} {{item.cdUnidadeMedida? '('+item.cdUnidadeMedida+')' : ''}}</span>
                                            </td>
                                            

                                            <td data-label="Ações" class="text-center action-cell" v-if="false">
                                                <div class="action-buttons">
                                                    <button class="action-btn action-btn-view d-none"
                                                            title="Informações">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                        </svg>
                                                        Informações
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="lstDados.length === 0">
                                            <td colspan="1" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h3 class="empty-title">Nenhuma dado encontrado</h3>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ModalDadosRegistroNecessidade',
        components: {
            
        },
        props: {
            showModal: Boolean,
            nomeProcesso: String,
            lstDados: Array,
        },
        computed: {
        },
        data: function () {
            return {
            }
        },
        methods: {
            load() {
            },

        },
        mounted: function () {
            this.myModalAlternative = new window.bootstrap.Modal('#ModalDadosRegistroNecessidade');

        },
        watch: {
            showModal: function () {
                
                this.myModalAlternative.show();
                this.load();
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff !important;
    }

        .btn-close-modern:hover {
            transform: scale(1.08);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        }

    .btn-md{
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 24px;
        position: relative;
    }
        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

    .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
        color: #2563eb;
    }

    .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .header-text p {
        margin: 6px 0 0;
        color: #475569;
        font-size: 14px;
        max-width: 420px;
        line-height: 1.4;
    }

    .modal-modern-body {
        padding: 28px 40px 40px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
    }

    .section-info {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .info-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
        color: #2563eb;
        background: rgba(37, 99, 235, 0.12);
        letter-spacing: 0.5px;
    }

    .section-title {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        color: #0f172a;
        letter-spacing: -0.2px;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.25s ease;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
        min-height: 44px;
        background: #1d4ed8;
        color: #fff;
    }

        .modern-btn svg {
            flex-shrink: 0;
        }

        .modern-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 24px rgba(37, 99, 235, 0.25);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    .permission-card {
        animation: fadeIn 0.25s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(12px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .card-modern {
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
        overflow: hidden;
    }

    .card-modern-header {
        padding: 24px 28px 12px;
    }

        .card-modern-header h4 {
            margin: 0;
            font-size: 18px;
            font-weight: 700;
            color: #0f172a;
        }

        .card-modern-header p {
            margin: 6px 0 0;
            color: #64748b;
            font-size: 14px;
        }

    .card-modern-body {
        padding: 0 28px 28px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .form-grid {
        display: grid;
        gap: 20px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
    }

    .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        padding: 12px 14px;
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff;
    }

        .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
            background: #ffffff;
        }

    .permission-options {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 14px;
        border-radius: 14px;
        border: 2px solid rgba(148, 163, 184, 0.2);
        background: rgba(241, 245, 249, 0.6);
        min-height: 90px;
    }

        .permission-options.has-error {
            border-color: #f87171;
            box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.18);
        }

    .permission-option {
        position: relative;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid rgba(148, 163, 184, 0.35);
        color: #1e293b;
        background: #ffffff;
        transition: all 0.2s ease;
    }

        .permission-option:hover {
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);
        }

        .permission-option.active {
            border-color: #2563eb;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            box-shadow: 0 10px 24px rgba(37, 99, 235, 0.35);
        }

    .permission-checkbox {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    .form-footer {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .border-danger {
        border-color: #f87171 !important;
        box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.18);
    }

    .table-section {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .table-section-header {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .section-subtitle {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
    }

    .section-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .table-wrapper {
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        overflow: hidden;
        background: #ffffff;
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
    }

    .custom-table {
        width: 100%;
        border-collapse: collapse;
    }

        .custom-table thead {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .custom-table th,
        .custom-table td {
            padding: 16px 18px;
            border-bottom: 1px solid rgba(148, 163, 184, 0.2);
            font-size: 14px;
            color: #1e293b;
        }

        .custom-table th {
            font-weight: 700;
            text-transform: uppercase;
            font-size: 13px;
            letter-spacing: 0.5px;
            color: #1f2937;
        }

    .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.08);
        transition: background 0.2s ease;
    }

    .user-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px 14px;
        border-radius: 999px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        color: #2563eb;
        font-weight: 600;
        border: 1px solid #bfdbfe;
    }

    .status-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        border: 1px solid transparent;
    }

    .status-chip-success {
        background: rgba(16, 185, 129, 0.12);
        color: #047857;
        border-color: rgba(16, 185, 129, 0.35);
    }

    .status-chip-danger {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

    .action-cell {
        white-space: nowrap;
    }

    .action-buttons {
        display: inline-flex;
        align-items: center;
        gap: 10px;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #f8fafc;
        color: #1f2937;
    }

        .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
    }

    .action-btn-delete {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: #ffffff;
            border-color: transparent;
        }

    .empty-state {
        text-align: center;
        padding: 60px 20px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #cbd5e1;
    }

    .empty-title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    @media (max-width: 768px) {
        .modal-modern-content {
            padding-top: 48px;
        }

        .modal-modern-header {
            padding: 28px 24px 18px;
            flex-direction: column;
        }

        .modal-modern-body {
            padding: 24px;
        }

        .section-header {
            flex-direction: column;
            align-items: stretch;
        }

        .modern-btn {
            width: 100%;
            justify-content: center;
        }

        .card-modern-header,
        .card-modern-body {
            padding-left: 20px;
            padding-right: 20px;
        }

        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

        .custom-table thead {
            display: none;
        }

        .custom-table tr {
            margin-bottom: 16px;
            border-radius: 14px;
            overflow: hidden;
            box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
        }

        .custom-table td {
            border: none;
            border-bottom: 1px solid rgba(148, 163, 184, 0.15);
            padding: 14px 16px;
            text-align: left !important;
        }

            .custom-table td:last-child {
                border-bottom: none;
            }

            .custom-table td::before {
                content: attr(data-label);
                display: block;
                font-weight: 700;
                margin-bottom: 6px;
                text-transform: uppercase;
                color: #64748b;
                font-size: 12px;
            }
    }

    .item-name {
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
        margin-bottom: 4px;
    }

    .item-details {
        font-size: 13px;
        color: #64748b;
    }
    .id-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        border: 1px solid rgba(148, 163, 184, 0.3);
        color: #475569;
    }
</style>

